import { render, staticRenderFns } from "./TableBody.vue?vue&type=template&id=72d74592&scoped=true&"
import script from "./TableBody.vue?vue&type=script&lang=ts&"
export * from "./TableBody.vue?vue&type=script&lang=ts&"
import style0 from "./TableBody.vue?vue&type=style&index=0&id=72d74592&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d74592",
  null
  
)

export default component.exports